export const SUBORGS_LIST_REQUEST = 'SUBORGS_LIST_REQUEST';
export const SUBORGS_LIST_SUCCESS = 'SUBORGS_LIST_SUCCESS';
export const SUBORGS_LIST_FAIL = 'SUBORGS_LIST_FAIL';
export const SUBORGS_LIST_UNLINK_SUBORG = 'SUBORGS_LIST_UNLINK_SUBORG';
export const SUBORGS_LIST_UNLINK_SUBORG_FAIL =
  'SUBORGS_LIST_UNLINK_SUBORG_FAIL';

export const SUBORGS_LIST_RESET_STATE = 'SUBORGS_LIST_RESET_STATE';
